export const HOME = '/';
export const LOGIN = 'login';
export const SIGN_UP = 'sign-up';
export const FORGOT_PASSWORD = 'forgot-password';
export const EMAIL_VERIFICATION = 'email-verification';
export const RESET_PASSWORD = 'reset-password';
export const SUPPORT = 'support';
export const PRIVACY_POLICY = 'privacy-policy';
export const TERMS_AND_CONDITIONS = 'terms-and-conditions';
export const PERSONAL_INFO = 'personal-info';
export const FACTS = 'facts';
export const CHANGE_PASSWORD = 'change-password';
export const FAQS = 'faqs';
export const PROFILE = 'profile';
export const EXAMPLES = 'examples';
export const FORBIDDEN = 'forbidden';
export const UPDATE_PASSWORD = 'update-password';
export const BASIC_INFO = 'basic-info';
export const SUBSCRIBE = 'subscribe';
export const TELEGRAM_INFO = 'telegram-info';
export const UPDATE_BASIC_INFO = 'update-basic-info';
export const UPLOAD_MEDIA = 'upload-media';
export const UPLOAD_FREE_PHOTOS = 'free-photos/self';
export const UPLOAD_PAID_PHOTOS = 'paid-photos/self';
export const UPLOAD_FREE_VIDEOS = 'free-videos/self';
export const UPLOAD_PAID_VIDEOS = 'paid-videos/self';
export const UPLOAD_FREE_ASSISTED_PHOTOS = 'free-photos/assisted';
export const UPLOAD_PAID_ASSISTED_PHOTOS = 'paid-photos/assisted';
export const UPLOAD_FREE_ASSISTED_VIDEOS = 'free-videos/assisted';
export const UPLOAD_PAID_ASSISTED_VIDEOS = 'paid-videos/assisted';
export const UPLOAD_BUNDLES = 'bundles';
export const UPLOAD_VOICE = 'voice';
export const MEDIA_PRICE = 'media-price';
export const PERSONALITY = 'personality';
export const ABOUT_YOU = 'about-you';
export const SUBSCRIPTIONS = 'subscriptions';
export const IN_REVIEW = 'in-review';
export const ID_VERIFICATION = 'id-verification';
export const WALLET = 'wallet';
export const REFERRALS = 'referrals';
export const GALLERY = 'gallery';
export const FREE_PHOTOS = 'free-photos';
export const PAID_PHOTOS = 'paid-photos';
export const FREE_VIDEOS = 'free-videos';
export const PAID_VIDEOS = 'paid-videos';
export const BUNDLES = 'bundles';
export const WITHDRAW = 'wallet/withdraw';
export const WITHDRAWAL_METHOD = 'wallet/withdrawal/method';
export const AGENCY_HOME = 'agency';
export const AGENCY_INFLUENCERS = 'creators';
export const AGENCY_SETTINGS = 'settings';
export const INFLUENCER = 'creators/:id';
export const INFLUENCER_ANALYTICS = 'overview';
export const INFLUENCER_FACTS = 'facts';
export const MESSAGES = 'messages';
export const CHAT = 'chat/:chatId';
export const COLLECTIONS = 'collections';
export const COLLECTION_USERS = ':collectionId';
export const VAULT = 'vault';
export const VAULT_MEDIA = 'media/:type';
export const VAULT_BUNDLE = 'bundle/:bundleId';
export const VAULT_FOLDER = 'folder/:folderId';
export const MASS_DM = 'messages/mass-dm';
export const NOTIFICATIONS = 'notifications';
export const CHATTER_HOME = 'organization/creators';
export const CHATTER_SETTINGS = 'organization/settings';
export const ORGANIZATION_MEMBERS = 'organization/members';
export const ORGANIZATION_ANALYTICS = 'organization/analytics';
export const MESSAGE_REVIEWS = 'organization/message-reviews';
export const ORGANIZATION_CHATTER_ANALYTICS = 'chatters';
export const ORGANIZATION_INFLUENCER_ANALYTICS = 'creators';
export const CHATTER_MESSAGES = ':influencerId/messages';
export const CHATTER_CHAT = 'chat/:chatId';
export const CHATTER_COLLECTIONS = ':influencerId/collections';
export const CHATTER_COLLECTION_USERS = ':collectionId';
export const CHATTER_VAULT = ':influencerId/vault';
export const CHATTER_VAULT_MEDIA = 'media/:type';
export const CHATTER_VAULT_BUNDLE = 'bundle/:bundleId';
export const CHATTER_VAULT_FOLDER = 'folder/:folderId';
export const CHATTER_MASS_DM = ':influencerId/messages/mass-dm';
export const CHATTER_NOTIFICATIONS = ':influencerId/notifications';
export const CHATTER_EDIT = ':influencerId/edit';
